export default "__VITE_ASSET__Cm9mRm5N__"